"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const grid_observer_1 = require("@ebay-business-components/grid-observer");
class MasonryGrid extends Marko.Component {
    onCreate(input) {
        var _a, _b;
        this.state = {
            items: [],
            gridObserver: new grid_observer_1.GridObserver(),
            resizeObserver: null,
            loading: (_a = input.loading) !== null && _a !== void 0 ? _a : false,
            imagesLoading: true,
            refreshKey: (_b = input.refreshKey) !== null && _b !== void 0 ? _b : 0,
        };
    }
    onInput(input) {
        var _a;
        if (!input.item) {
            throw new Error('[MASONRY GRID] Missing required input: <@item>');
        }
        if (input.loading !== undefined) {
            this.state.loading = input.loading;
        }
        const nextInput = [input.item].flat();
        const lastId = (_a = this.state.items[this.state.items.length - 1]) === null || _a === void 0 ? void 0 : _a.id;
        const shouldRefresh = typeof this.state.refreshKey === 'number' &&
            this.state.refreshKey !== input.refreshKey;
        if (shouldRefresh)
            this.gridObserver.reset();
        const nextItems = this.gridObserver.initGridItems(nextInput.slice(this.gridObserver.initializedItemCount));
        if (nextItems.length) {
            if (shouldRefresh)
                this.state.refreshKey = input.refreshKey;
            if (!shouldRefresh)
                this.gridObserver.focusId = lastId;
            const currentItems = shouldRefresh ? [] : this.state.items;
            this.state.items = [...currentItems, ...nextItems];
            this.state.loading = true;
            this.state.imagesLoading = true;
        }
    }
    onMount() {
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(() => {
                this.resizeGridItems();
            });
            resizeObserver.observe(this.gridWrapper);
            this.state.resizeObserver = resizeObserver;
        }
        else {
            this.resizeGridItems();
        }
    }
    onUpdate() {
        this.resizeGridItems();
        this.gridObserver.handleGridItemsUpdate(this.state.items, this.handleImageLoad.bind(this));
    }
    onDestroy() {
        var _a;
        (_a = this.state.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.state.gridObserver.destroy();
    }
    resizeGridItems() {
        this.gridObserver.resizeGridItems(this.grid, this.gridStyleProxy);
    }
    handleImageLoad() {
        this.resizeGridItems();
        this.gridObserver.incrementProcessedItemCount(1);
        const { processedItemCount, initializedItemCount } = this.gridObserver;
        if (processedItemCount === initializedItemCount) {
            this.state.loading = false;
            this.state.items = this.gridObserver.setImageAspectRatios(this.state.items);
            setTimeout(() => {
                this.state.imagesLoading = false;
            }, 1000);
        }
    }
    onLoadMore() {
        this.state.loading = true;
        this.emit('load-more');
    }
    onHeaderLinkClick() {
        this.emit('header-link-click');
    }
    get gridObserver() {
        return this.state.gridObserver;
    }
    get gridWrapper() {
        const gridWrapper = this.grid.parentElement;
        if (!gridWrapper) {
            throw new Error('Grid wrapper element not found');
        }
        return gridWrapper;
    }
    get grid() {
        const grid = this.getEl('grid');
        if (!(grid instanceof HTMLElement)) {
            throw new Error('Grid element not found');
        }
        return grid;
    }
    get gridStyleProxy() {
        const gridProxy = this.getEl('grid-style-proxy');
        if (!(gridProxy instanceof HTMLElement)) {
            throw new Error('Grid element not found');
        }
        return gridProxy;
    }
    get gridItemEls() {
        return this.grid.querySelectorAll('[data-masonry-item]');
    }
}
exports.default = MasonryGrid;
//# sourceMappingURL=component.js.map